module.exports = __webpack_public_path__ + "ps.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ps.svg
// module id = 767
// module chunks = 0